var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilledStarMultiple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.107172,
    height: 24,
    viewBox: "0 0 6.378356 6.3499998",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1881"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.9,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect1883",
    width: 5.314919,
    height: 5.0295367,
    x: 98.367348,
    y: 35.933678
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1885"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.9,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect1887",
    width: 5.314919,
    height: 5.0295367,
    x: 98.367348,
    y: 35.933678
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-99.892536,-38.500659)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1879",
    clipPath: "none",
    transform: "translate(2.5838216,2.5709025)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4659",
    transform: "translate(2.583821,2.5709038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 101.04124,40.370401 1.63512,0.986896 -0.43391,-1.860021 1.44462,-1.251479 -1.90235,-0.164042 -0.74348,-1.751542 -0.74348,1.751542 -1.902356,0.164042 1.441979,1.251479 -0.431271,1.860021 z",
    id: "path9",
    style: {
      strokeWidth: 0.264583
    },
    clipPath: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 97.609375,38.268732 -0.300781,0.355468 0.177734,0.150451 1.216797,1.025391 -0.220703,0.876893 -0.05664,0.226562 0.451172,0.113281 0.05664,-0.224609 0.291015,-1.160156 -1.4375,-1.212891 z",
    id: "path5104",
    transform: "translate(2.583821,2.5709038)"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.96,
      fill: "none",
      strokeWidth: 0.244664,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect1891",
    width: 5.4427171,
    height: 5.0367694,
    x: 98.209473,
    y: 35.91893,
    clipPath: "url(#clipPath1881)",
    transform: "translate(2.5838216,2.5709025)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStarMultiple);
export default __webpack_public_path__ + "static/media/filled-star-multiple.cd31a5e44a188cb71131ff22d2ad615d.svg";
export { ForwardRef as ReactComponent };